import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { map, catchError } from 'rxjs/operators';

import { SecurityService } from '../../Core/Security/security.service';
import { ConfigService } from '../../Core/Abstract/config.service';
import { LogService } from '../../Core/Abstract/log.service';
import * as FileSaver from 'file-saver';

import { EventsEmitterService } from '../../Core/Abstract/emitter.service';
import { Router } from '@angular/router';

@Injectable()

export class DocumentsService extends SecurityService{

     constructor(http:HttpClient,configService:ConfigService,eventsEmitterService: EventsEmitterService, router:Router, logger:LogService) {
        super(http,configService,eventsEmitterService, router ,logger);
    }
    
    getDocuments(): Observable<any>{
        let serviceUrl = this.baseUrl  + 'DocumentsService/getDocuments?'
                                       
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    downloadFile(path: string, name:string): Observable<Blob> {
        var namex = name;
        let headers = new HttpHeaders({ 'Content-Type': 'application/json'});
        let options = ({ headers: headers, 'observe': 'response',responseType: 'blob' });
        
        return this.http.post<any>(this.baseUrl + 'DocumentsService/download?'
                                         + 'path='+path,options)                                             
        .pipe(map(function(res){ 
            let blob = new Blob([res.blob()], { type: res.headers.get('content-type')});
            FileSaver.saveAs(blob, namex);
            return blob;
        })
        ,catchError(this.handleError));      
    }
}